var exports = {
  "q": "x93eb46d8--2d3a01--layer",
};

module.exports = exports;
